import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  DynamicSchemaDefinitionFiles,
  DynamicSchemaDefinitionFixed,
  DynamicSchemaDefinitionMultiLineText,
  DynamicSchemaDefinitionPositiveInteger,
  DynamicSchemaDefinitionSelectMultiple,
  DynamicSchemaDefinitionSelectOne,
  DynamicSchemaDefinitionSingleLineText,
  DynamicSchemaDefinitionToggle,
} from '../../../../../graphql/generated/graphql';
import Base from './Base';

interface Props {
  field:
    | Pick<DynamicSchemaDefinitionFiles, 'type' | 'label'>
    | Pick<DynamicSchemaDefinitionFixed, 'type' | 'label'>
    | Pick<DynamicSchemaDefinitionMultiLineText, 'type' | 'label'>
    | Pick<DynamicSchemaDefinitionPositiveInteger, 'type' | 'label'>
    | Pick<DynamicSchemaDefinitionSelectMultiple, 'type' | 'label'>
    | Pick<DynamicSchemaDefinitionSelectOne, 'type' | 'label'>
    | Pick<DynamicSchemaDefinitionSingleLineText, 'type' | 'label'>
    | Pick<DynamicSchemaDefinitionToggle, 'type' | 'label'>;
  className?: string;
}

const AsEmpty = ({ field, className }: Props & ClassAttributes<HTMLElement>) => {
  return (
    <Base field={field} className={className}>
      <Value>
        <FormattedMessage
          id={field.type === 'FILES' ? 'creative_brief_detail.field.files.empty' : 'creative_brief_detail.field.empty'}
        />
      </Value>
    </Base>
  );
};

const Value = styled(Typography)({
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
});

export default AsEmpty;
